/* eslint-disable @typescript-eslint/camelcase */
import { Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import Breadcrumbs, { BreadcrumbsFields } from 'components/Breadcrumbs';
import PageTitle from 'components/PageTitle';
import i18n from 'i18n';
import styles from './styles';
import NavBarPartners from '../NavBarPartners';

const useStyles = makeStyles(styles);

interface TemplateProps {
  current: 'configuration' | 'servers' | 'instances' | 'custom-front';
  title?: string;
  breadcrumbs?: BreadcrumbsFields[];
  subtitle?: string;
  children?: React.ReactNode;
  button?: React.ReactNode;
  headerComponent?: React.ReactNode;
  partnerName: string | undefined;
}

const PartnersTemplate = ({
  current,
  subtitle,
  title,
  children,
  button,
  headerComponent,
  partnerName,
  breadcrumbs,
}: TemplateProps) => {
  const classes = useStyles();

  return (
    <Grid container>
      <Grid container justify="flex-start">
        <PageTitle
          title={partnerName || `${i18n.t('LOADING_KEY')}...`}
          subtitle={breadcrumbs ? <Breadcrumbs values={breadcrumbs} /> : ''}
        />
      </Grid>
      <NavBarPartners current={current} />
      <Grid className={classes.sectionTitle}>
        {!!headerComponent && headerComponent}
        <Grid className={classes.headerContent} container>
          <PageTitle title={title} subtitle={subtitle} />
          {!!button && button}
        </Grid>
        {children}
      </Grid>
    </Grid>
  );
};

export default PartnersTemplate;
